import TabletMpProvider from "@/core/data-provider/data-mp/tablet/tablet-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export default async function closeTablet() {
  try {
    const response = await TabletMpProvider.hide();

    if (response instanceof RpcMpProviderFailedResponse) {
      console.error("Failed to fetch TabletMpProvider.hide()");
    }
  } catch (e) {
    console.error("Failed to fetch TabletMpProvider.hide()", e);
  }
}
